export const uploadConstant = {
    GET_BULK_UPLOAD_MODULES: 'GET_BULK_UPLOAD_MODULES',
    GET_BULK_UPLOAD_CSV_FILE_MASTER_DETAILS_SUCCESS: 'GET_BULK_UPLOAD_CSV_FILE_MASTER_DETAILS_SUCCESS',
    GET_BULK_UPLOAD_CSV_FILE_MASTER_DETAILS_FAILED: 'GET_BULK_UPLOAD_CSV_FILE_MASTER_DETAILS_FAILED',
    GET_BULK_UPLOAD_CSV_FILE_MASTER_DETAILS_PENDING: 'GET_BULK_UPLOAD_CSV_FILE_MASTER_DETAILS_PENDING',
}